import { render, staticRenderFns } from "./modalCancelarPedidoDirecto.vue?vue&type=template&id=195040f4&scoped=true&"
import script from "./modalCancelarPedidoDirecto.vue?vue&type=script&lang=js&"
export * from "./modalCancelarPedidoDirecto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195040f4",
  null
  
)

export default component.exports